module.exports = __webpack_public_path__ + "static/img/search.dd49f473.svg";